import { NgxSpinnerService } from 'ngx-spinner';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';


@Injectable()
export class AppInterceptor implements HttpInterceptor {

    constructor(public _autenticacionService: AuthenticationService,
        private route: ActivatedRoute,
        private router: Router,
        private spinner: NgxSpinnerService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this._autenticacionService.isLoggedIn) {
            const timeRestante = this._autenticacionService.obtenerTiempoRestanteToken();
            if (timeRestante !== undefined) {
                if (timeRestante <= 100 && !this._autenticacionService.onrefreshToken()) {
                    this._autenticacionService.obtenerRefreshTokenJWT();
                }
            }

            request = this.addCustomHeaders(request,
                this._autenticacionService.obtenerTokenJWTAlmacenado()
            );
        }

        return <any>next.handle(request).pipe(
            catchError(async (err: HttpErrorResponse) => {
                if (err.status === 401) {
                    this.spinner.hide();
                    const url: string = this.route.snapshot['_routerState'].url;
                    if (url.indexOf('perfil-club') > -1) {
                        console.log('redireccionando a login desde ', url);
                        this.router.navigate(['enjoy-club/login'], { queryParams: { returnUrl: request.url } });
                    }
                }
                throw err;
            })
        );
    }
    private addCustomHeaders(request: HttpRequest<any>,
        token: string) {
        return request.clone({
            setHeaders: {
                'Authorization': `Bearer ${token}`,
            }
        });
    }
    private addToken(request: HttpRequest<any>, token: string) {
        return request.clone({
            setHeaders: {
                'Authorization': `Bearer ${token}`
            }
        });
    }
}
